'use client';

import { useCallback, useState } from 'react';
import { useActiveControlProps } from './types';

export const useActiveControl = ({
  initialActive = false
}: useActiveControlProps = {}) => {
  const [isActive, setIsActive] = useState(initialActive);

  const open = useCallback(() => setIsActive(true), []);
  const close = useCallback(() => setIsActive(false), []);
  const toggle = useCallback(() => setIsActive((prev) => !prev), []);

  return { isActive, open, close, toggle };
};
